import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineCommentEventsApi } from '@/features/api/hooks/grapevine-comment-events/useGrapevineCommentEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useDeleteComment = (postId?: string) => {
  const queryClient = useQueryClient();
  const api = useGrapevineCommentEventsApi();

  return useApiMutation({
    mutationFn: (commentId: string) =>
      api.onCommentDeleteRequest({
        clientCommentDeleteRequest: { commentId }
      }),
    onSuccess: () =>
      queryClient.refetchQueries({
        queryKey: [API_CACHE_KEYS.COMMENTS, postId]
      })
  });
};
